import React from 'react'
import Select from "react-select";
const ReactSelect = ({defaultValue, options, onChange, isDisabled=false, otherProps = {}, cutomeHeight="25px"}) => {
  return <>
    <>
      <Select
        options={options}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ensure it's above other elements,
          control: (base) => ({
            ...base,
            minHeight: cutomeHeight,
            height: cutomeHeight,
          }),
          valueContainer: (base) => ({
            ...base,
            height: cutomeHeight,
            padding: '0 6px',
          }),
          input: (base) => ({
            ...base,
            margin: 0,
            padding: 0,
            height: cutomeHeight, // controls the inner input height
          }),
          indicatorsContainer: (base) => ({
            ...base,
            height: cutomeHeight,
          }),
          singleValue: (base) => ({
            ...base,
            lineHeight: cutomeHeight,
          }),
        }}
        isClearable={true}
        onChange={onChange}
        defaultValue={defaultValue}
        isDisabled={isDisabled}
        {...otherProps}
      />
    </>
  </>
}

export default ReactSelect